/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge, VariantBadge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  EnumTypeAccessRequest,
  StatusEnumAccessRequest,
} from "@/enum/access_request";
import { format } from "date-fns";
import {
  CheckCheckIcon,
  FileSignature,
  FileText,
  MessageSquare,
} from "lucide-react";

interface TimelineEvent {
  id: string;
  created_at: string;
  type: EnumTypeAccessRequest;
  status?: "aprovado" | "rejeitado" | "pendente";
  comment?: string;
  responsible: string;
  details?: string;
}

interface HistoricoTimelineProps {
  event: TimelineEvent[];
}

export function HistoricoTimeline({ event }: HistoricoTimelineProps) {
  const getIconForEventType = (type: TimelineEvent["type"]) => {
    const objectTypes = {
      [EnumTypeAccessRequest.CREATED]: (
        <FileText className="w-6 h-6 text-blue-500" />
      ),
      [EnumTypeAccessRequest.FEEDBACK]: (
        <MessageSquare className="w-6 h-6 text-green-500" />
      ),
      [EnumTypeAccessRequest.UPDATED]: (
        <CheckCheckIcon className="w-6 h-6 text-blue-500" />
      ),
    };
    return (
      objectTypes[type] || <FileSignature className="w-6 h-6 text-gray-500" />
    );
  };

  // const getEventTitle = (event: TimelineEvent) => {
  //   const objectTypes = {
  //     [EnumTypeAccessRequest.CREATED]: "Criação",
  //     [EnumTypeAccessRequest.FEEDBACK]: "Devolutiva",
  //     [EnumTypeAccessRequest.UPDATED]: "Atualização de Contrato",
  //   };
  //   return objectTypes[event.type as keyof typeof objectTypes] || "Evento";
  // };

  const getStatusBadge = (status: TimelineEvent["status"]) => {
    const objectTypes = {
      [StatusEnumAccessRequest.COMPLETED]: "success",
      [StatusEnumAccessRequest.REJECTED]: "destructive",
      [StatusEnumAccessRequest.PENDING]: "default",
    };
    return objectTypes[status as keyof typeof objectTypes] || "default";
  };

  const getStatusBadgeTitle = (status: TimelineEvent["status"]) => {
    const objectTypes = {
      [StatusEnumAccessRequest.COMPLETED]: "Aprovado",
      [StatusEnumAccessRequest.REJECTED]: "Rejeitado",
      [StatusEnumAccessRequest.PENDING]: "Pendente",
    };
    return objectTypes[status as keyof typeof objectTypes] || "Pendente";
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Histórico de requisição</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-auto pr-4">
          <div className="relative">
            {event?.map((event, index) => (
              <div key={event?.id} className="mb-8 flex">
                <div className="flex flex-col items-center mr-4">
                  <div className="flex justify-center items-center w-12 h-12 rounded-full bg-gray-200">
                    {getIconForEventType(event.type)}
                  </div>
                  {index !== (event as any).length - 1 && (
                    <div className="w-0.5 h-full bg-gray-300 mt-2"></div>
                  )}
                </div>
                <div className="flex-grow">
                  <div className="flex items-center mb-1">
                    {/* <h3 className="text-lg font-semibold mr-2">
                      {getEventTitle(event)}
                    </h3> */}
                    {event?.status && (
                      <Badge
                        variant={getStatusBadge(event?.status) as VariantBadge}
                      >
                        {getStatusBadgeTitle(event.status)
                          .charAt(0)
                          .toUpperCase() +
                          getStatusBadgeTitle(event.status).slice(1)}
                      </Badge>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">
                    {format(new Date(event?.created_at), "dd/MM/yyyy")}
                  </p>
                  {event?.comment && (
                    <p className="text-sm mb-2">{event?.comment}</p>
                  )}
                  {event?.details && (
                    <p className="text-sm mb-2">{event?.details}</p>
                  )}
                  <p className="text-xs text-muted-foreground">
                    Responsável: {event?.responsible}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
